import React, { useState, useEffect } from "react";
import { Col, Container, Row, Table, Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  useGetSubCategoryQuery,
  useDeleteCategoryMutation,
} from "../../../../store/services/categoryService";
import moment from "moment";
import ConfirmationPop from "../../../../components/Modals/ConfirmationPop";
import TableLayout from "../../../../components/TableLayout";
import { CstmPagination } from "../../../../components/Common/Common";
import toast from "react-hot-toast";
import SubCategoryPop from "../../../../components/Modals/SubCategoryPop";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import { CATEGORY_TYPE } from "../../../../constants/enum";

const SubCategory = () => {
  // Get id from URL
  const { id } = useParams();
  const [confirmation, setConfirmation] = useState();
  const [bodyData, setBodyData] = useState({
    limit: 50,
    pageNo: 1,
    orderBy: "createdAt",
    order: 1,
    parentCategory: id,
    type: CATEGORY_TYPE.MEAL,
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [edit, setEdit] = useState(null);
  const handleConfirmation = () => setConfirmation(!confirmation);
  const { data: User, error, isLoading } = useGetSubCategoryQuery(bodyData);
  const [deleteCategory, { isLoading: isDeleting }] =
    useDeleteCategoryMutation();

  useEffect(() => {
    if (modalOpen === false && edit !== null) {
      setEdit(null);
    }
  }, [modalOpen]);

  if (error) {
    return <p>Something went wrong: {error.message}</p>;
  }

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        const startingIndex = (bodyData.pageNo - 1) * bodyData.limit; // Calculate starting index based on pageNo and limit
        const serialNumber = startingIndex + key + 1; // Calculate serial number based on key and starting index

        return <>{serialNumber < 10 ? `0${serialNumber}` : serialNumber}</>;
      },
    },
    {
      head: "Name",
      accessor: "name",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">{item.name}</p>
      ),
    },

    {
      head: "Created At",
      accessor: "createdAt",
      component: (item, key, arr) => (
        <>{moment(item.createdAt).format("DD/MM/YYYY")}</>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">{item.status}</p>
      ),
    },

    {
      head: "Actions",
      accessor: "Action",
      component: (item, key, arr) => (
        <div className="actionBtn d-flex align-items-center gap-10">
          <Button
            type="button"
            className="border-0 p-0"
            variant="transparent"
            onClick={() => {
              setModalOpen(true);
              setEdit(item);
            }}
            title="edit"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 19 19"
              fill="none"
            >
              <g clip-path="url(#clip0_0_1398)">
                <path
                  d="M3.36751 15.785C3.54751 15.785 3.58351 15.767 3.74551 15.731L6.98551 15.083C7.32751 14.993 7.66951 14.831 7.93951 14.561L15.7875 6.71301C16.9935 5.50701 16.9935 3.43701 15.7875 2.23101L15.1215 1.52901C13.9155 0.323012 11.8275 0.323012 10.6215 1.52901L2.77351 9.39501C2.52151 9.64701 2.34151 10.007 2.25151 10.349L1.56751 13.625C1.47751 14.237 1.65751 14.831 2.08951 15.263C2.43151 15.605 2.93551 15.785 3.36751 15.785ZM3.97951 10.691L11.8275 2.82501C12.3495 2.30301 13.3035 2.30301 13.8075 2.82501L14.4915 3.50901C15.1035 4.12101 15.1035 4.98501 14.4915 5.57901L6.66151 13.445L3.33151 14.003L3.97951 10.691ZM15.7155 16.901H2.43151C1.90951 16.901 1.56751 17.243 1.56751 17.765C1.56751 18.287 1.99951 18.629 2.43151 18.629H15.6435C16.1655 18.629 16.5975 18.287 16.5975 17.765C16.5795 17.243 16.1475 16.901 15.7155 16.901Z"
                  fill="#27AE60"
                  stroke="#F8FAFC"
                  stroke-width="0.3"
                />
              </g>
              <defs>
                <clipPath id="clip0_0_1398">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0.127441 0.628906)"
                  />
                </clipPath>
              </defs>
            </svg>
          </Button>
          <Button
            onClick={() => {
              handleConfirmation();
              setDeleteId(item._id);
            }}
            //onClick={() => confirmHandler()}
            className="border-0 p-0"
            variant="transparent"
            title="delete"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="19"
              viewBox="0 0 17 19"
              fill="none"
            >
              <g clip-path="url(#clip0_0_1356)">
                <path
                  d="M10.3149 14.4727C10.4807 14.4727 10.6397 14.4068 10.7569 14.2896C10.8741 14.1724 10.9399 14.0134 10.9399 13.8477V7.59766C10.9399 7.4319 10.8741 7.27292 10.7569 7.15571C10.6397 7.0385 10.4807 6.97266 10.3149 6.97266C10.1492 6.97266 9.99021 7.0385 9.873 7.15571C9.75579 7.27292 9.68994 7.4319 9.68994 7.59766V13.8477C9.68994 14.0134 9.75579 14.1724 9.873 14.2896C9.99021 14.4068 10.1492 14.4727 10.3149 14.4727ZM5.93994 14.4727C6.1057 14.4727 6.26467 14.4068 6.38188 14.2896C6.49909 14.1724 6.56494 14.0134 6.56494 13.8477V7.59766C6.56494 7.4319 6.49909 7.27292 6.38188 7.15571C6.26467 7.0385 6.1057 6.97266 5.93994 6.97266C5.77418 6.97266 5.61521 7.0385 5.498 7.15571C5.38079 7.27292 5.31494 7.4319 5.31494 7.59766V13.8477C5.31494 14.0134 5.38079 14.1724 5.498 14.2896C5.61521 14.4068 5.77418 14.4727 5.93994 14.4727ZM10.6274 2.28516C10.7932 2.28516 10.9522 2.21931 11.0694 2.1021C11.1866 1.98489 11.2524 1.82592 11.2524 1.66016C11.2524 1.4944 11.1866 1.33542 11.0694 1.21821C10.9522 1.101 10.7932 1.03516 10.6274 1.03516H5.62744C5.46168 1.03516 5.30271 1.101 5.1855 1.21821C5.06829 1.33542 5.00244 1.4944 5.00244 1.66016C5.00244 1.82592 5.06829 1.98489 5.1855 2.1021C5.30271 2.21931 5.46168 2.28516 5.62744 2.28516H10.6274Z"
                  fill="#EB5757"
                />
                <path
                  d="M1.25244 2.91016C1.08668 2.91016 0.92771 2.976 0.8105 3.09321C0.69329 3.21042 0.627441 3.3694 0.627441 3.53516C0.627441 3.70092 0.69329 3.85989 0.8105 3.9771C0.92771 4.09431 1.08668 4.16016 1.25244 4.16016H1.87744V15.6602C1.87744 17.0727 3.02744 18.2227 4.43994 18.2227H11.8149C13.2274 18.2227 14.3774 17.0727 14.3774 15.6602V4.16016H15.0024C15.1682 4.16016 15.3272 4.09431 15.4444 3.9771C15.5616 3.85989 15.6274 3.70092 15.6274 3.53516C15.6274 3.3694 15.5616 3.21042 15.4444 3.09321C15.3272 2.976 15.1682 2.91016 15.0024 2.91016H2.50244H1.25244ZM13.1274 4.16016V15.6602C13.1274 16.0083 12.9892 16.3421 12.743 16.5882C12.4969 16.8344 12.163 16.9727 11.8149 16.9727H4.43994C4.09185 16.9727 3.75801 16.8344 3.51186 16.5882C3.26572 16.3421 3.12744 16.0083 3.12744 15.6602V4.16016H13.1274Z"
                  fill="#EB5757"
                />
              </g>
              <defs>
                <clipPath id="clip0_0_1356">
                  <rect
                    width="16"
                    height="18"
                    fill="white"
                    transform="translate(0.127441 0.628906)"
                  />
                </clipPath>
              </defs>
            </svg>
          </Button>
        </div>
      ),
    },
  ];

  const confirmHandler = async () => {
    try {
      await deleteCategory(deleteId).unwrap(); // Call deleteMeal and handle success
      setConfirmation(false);
      return toast.success("Category deleted successfully");
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const handlePageChange = (selectedPage) => {
    setBodyData((prevState) => ({
      ...prevState,
      pageNo: selectedPage.selected + 1, // Update the page number (selected is 0-based index)
    }));
  };

  return (
    // <section className="userDetail py-3 position-relative">
    //   <Container>
    //     <Row>
    //       <Col lg="12">
    //         <div className="d-flex align-items-center gap-10">
    //           <Link
    //             to="/manage-category"
    //             className="border d-flex align-items-center p-2 rounded"
    //           >
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="12"
    //               height="12"
    //               viewBox="0 0 10 16"
    //               fill="none"
    //             >
    //               <path
    //                 d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
    //                 fill="#1E232C"
    //                 stroke="#1E232C"
    //                 strokeWidth="0.2"
    //               />
    //             </svg>
    //           </Link>
    //           <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
    //             Sub Category
    //           </h4>
    //         </div>
    //       </Col>

    //       <Col lg="12" className="my-2">
    //         <div
    //           className="formWrapper px-lg-5 p-md-4 p-3 rounded"
    //           style={{ background: "#EEEEEE" }}
    //         >
    //           {isLoading ? (
    //             <div className="text-center">
    //               <div className="spinner-border text-dark" role="status">
    //                 <span className="sr-only">Loading...</span>
    //               </div>
    //             </div>
    //           ) : error ? (
    //             <div className="text-center text-danger">
    //               Something went wrong. Please try again.
    //             </div>
    //           ) : (
    //             User?.data && (
    //               <Table striped bordered hover responsive className="mt-3">
    //                 <thead className="bg-dark text-white">
    //                   <tr>
    //                     <th>Sr. No.</th>
    //                     <th>Name</th>
    //                     <th>Created At</th>
    //                     <th>Status</th>
    //                   </tr>
    //                 </thead>
    //                 <tbody>
    //                   {User.data.map((item, index) => (
    //                     <tr key={item._id}>
    //                       <td>{index + 1}</td>
    //                       <td className="m-0 themeBlue fw-sbold">{item.name || "N/A"}</td>
    //                       <td>
    //                         {moment(item.createdAt).format("DD/MM/YYYY")}
    //                       </td>
    //                       <td className="m-0 themeBlue fw-sbold">{item.status || "N/A"}</td>
    //                     </tr>
    //                   ))}
    //                 </tbody>
    //               </Table>
    //             )
    //           )}
    //         </div>
    //       </Col>
    //     </Row>
    //   </Container>
    // </section>

    <>
      {modalOpen && (
        <SubCategoryPop
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          title={`${edit ? "Edit" : "Add"}  Sub Category`}
          edit={edit}
          User={User}
        />
      )}

      <ConfirmationPop
        confirmation={confirmation}
        setConfirmation={setConfirmation}
        confirmHandler={confirmHandler}
        type="delete"
      />

      <section className="manageusers py-3 position-relative">
        <Container>
          <Row>
            {/* <Col lg="12">
          <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
            Category
          </h4>
        </Col> */}

            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/manage-category"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  Sub Category
                </h4>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left"></div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    {/* <li className="">
                  <button
                    type="button"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                    onClick={() => {
                      setModalOpen(true);
                    }}
                  >
                    Add Category
                  </button>
                </li> */}
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              {isLoading && (
                <div className="text-center">
                  <div className="spinner-border text-dark" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
              {!isLoading && User?.data?.length > 0 && (
                <TableLayout column={column} data={User?.data} />
              )}
              {!isLoading && User?.data?.length === 0 && (
                <div className="text-center">No data Found</div>
              )}
              {User?.data?.length > 0 && (
                <CstmPagination
                  pageCount={User?.totalcount / bodyData.limit}
                  onPageChange={handlePageChange}
                  itemsPerPage={bodyData.limit}
                  totalItems={User?.totalcount}
                  currentPage={User?.page}
                />
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SubCategory;

// import React, { useEffect, useState } from "react";
// import { Col, Container, Form, Row } from "react-bootstrap";
// import { Link, useParams } from "react-router-dom";

// // img
// // import i1 from "@/Assets/images/authBg.png";
// import i1 from "../../../../Assets/images/authBg.png";
// import { useGetRefundDetailsQuery } from "../../../../store/services/refundService";
// import { useGetSubCategoryQuery } from "../../../../store/services/categoryService";
// import moment from "moment";

// const SubCategory = () => {
//   // get id from url
//   const { id } = useParams();

//   const [bodyData, setBodyData] = useState({
//     "limit": 50,
//     "pageNo": 1,
//     "orderBy": "createdAt",
//     "order": 1,
//     "parentCategory" : id,
//   });

//   console.log("param id",id);

//    const { data: User, error, isLoading } = useGetSubCategoryQuery(bodyData);

//    console.log("user==>",User);

//   // console.log("user ======>", User);

//   // if (error) {
//   //   return <div>Something went wrong</div>;
//   // }

//   return (
//     <section className="userDetail py-3 position-relative">
//       <Container>
//         <Row>
//           <Col lg="12">
//             <div className="d-flex align-items-center gap-10">
//               <Link
//                 to="/manage-category"
//                 className="border d-flex align-items-center p-2 rounded"
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="12"
//                   height="12"
//                   viewBox="0 0 10 16"
//                   fill="none"
//                 >
//                   <path
//                     d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
//                     fill="#1E232C"
//                     stroke="#1E232C"
//                     stroke-width="0.2"
//                   />
//                 </svg>
//               </Link>
//               <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
//                 Sub Category
//               </h4>
//             </div>
//           </Col>

//           <Col lg="12" className="my-2">
//             <div
//               className="formWrpper px-lg-5 p-md-4 p-3 rounded"
//               style={{ background: "#EEEEEE" }}
//             >
//               {isLoading && (
//                 <div className="text-center">
//                   <div className="spinner-border text-dark" role="status">
//                     <span className="sr-only">Loading...</span>
//                   </div>
//                 </div>
//               )}
//               {!isLoading && User?.data && (
//                 <Row className="justify-content-between">

//                   <Col md={6} className="my-2">
//                     <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
//                       <li className="py-3 d-flex align-items-center gap-10">
//                         <p className="m-0 themeBlue fw-sbold w-25">
//                           Name:
//                         </p>
//                         <h6 className="m-0 text-muted fw-bold w-50">
//                           {/* {User?.data?.name} */}
//                           {User?.data?.[0]?.name}

//                         </h6>
//                       </li>

//                       <li className="py-3 d-flex align-items-center gap-10">
//                         <p className="m-0 themeBlue fw-sbold w-25">
//                           Created at:
//                         </p>
//                         <h6 className="m-0 text-muted fw-bold w-50">
//                           {/* {moment(User?.data.createdAt).format("DD/MM/YYYY")} */}
//                           {moment(User?.data?.[0]?.createdAt).format("DD/MM/YYYY")}
//                         </h6>
//                       </li>

//                       <li className="py-3 d-flex align-items-center gap-10">
//                         <p className="m-0 themeBlue fw-sbold w-25">Status:</p>
//                         <h6 className="m-0 text-muted fw-bold w-50 text-capitalize">
//                           {/* {User?.data?.status} */}
//                           {User?.data?.[0]?.status}
//                         </h6>
//                       </li>
//                     </ul>
//                   </Col>
//                 </Row>
//               )}
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default SubCategory;
